import React from 'react';
import classNames from 'classnames';

interface TRowProps {
  // id?: string;
  className?: string;
}

const TRow: React.FC<TRowProps & React.HTMLAttributes<HTMLTableRowElement>> = props => {
  const { /* id, */ className, children, ...restProps } = props;
  return (
    <tr /* id={id} */ className={classNames(className)} {...restProps}>
      {children}
    </tr>
  );
};

export default TRow;
